import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import { fetchNavigationData } from './actions/navigationData';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';


const store = createStore(rootReducer, applyMiddleware(thunk));
store.dispatch(fetchNavigationData());

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter >
      <App />
    </BrowserRouter >
  </Provider>, document.getElementById('root')
);
